module.exports = __webpack_public_path__ + "img/behavior_insight.b8789248.jpg";